import React from 'react';
import { Helmet } from 'react-helmet';
import { Loader } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import DisableUserSelect from 'components/DisableUserSelect';
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import HarvestEventsRequest from 'components/HarvestEventsRequest';
// @ts-ignore
import InitialDataLoadedErrorGate from 'components/InitialDataLoadedErrorGate';
// @ts-ignore
import InitialDataLoadedGate from 'components/InitialDataLoadedGate';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
// @ts-ignore
import Online from 'components/Online';
import SchemasWithEventTypeIdExistGate from 'components/SchemasWithEventTypeIdExistGate';
import PickScheduleLayoutGate from 'components/PickScheduleLayoutGate';
import SaveMessage from 'components/SaveMessage';

// @ts-ignore
import SeasonalEventDialog from '../../components/SeasonalEventDialog';
import EventsTable from './components/EventsTable';
// @ts-ignore
import EventsTimeline from './components/EventsTimeline';
// @ts-ignore
import ResizableContainer from './components/ResizableContainer';
// @ts-ignore
import EventDragLayer from './components/EventDragLayer';
// @ts-ignore
import UnscheduleEventModal from './components/UnscheduleEventModal';
import HarvestEventsTable from './components/HarvestEventsTable';
import PickSchedulePageTitleAndFilters from './components/PickSchedulePageTitleAndFilters';

// Styles
import './styles.scss';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const PickSchedule = (): React.ReactElement => (
    <ErrorBoundary
        namespace="PickSchedule"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <SchemasWithEventTypeIdExistGate
            FallbackComponent={<Redirect to="/organization/jobs/planner" />}
        >
            <Helmet>
                <title>Pick Schedule - {REACT_APP_PROJECT_NAME}</title>
            </Helmet>
            <Online>
                <HarvestEventsRequest />
            </Online>

            <PickScheduleLayoutGate targetedLayout="table">
                <React.Fragment>
                    <PickSchedulePageTitleAndFilters
                        MessageComponent={
                            <SaveMessage namespace={['HARVEST_EVENTS_SAVE']} />
                        }
                    />
                    <InitialDataLoadedErrorGate
                        namespace="HARVEST_EVENTS_LOAD"
                        displayLogoutButton
                    >
                        <InitialDataLoadedGate
                            namespace="HARVEST_EVENTS_LOAD"
                            LoadingComponent={
                                <PageWrapper>
                                    <Loader active inline="centered" />
                                </PageWrapper>
                            }
                        >
                            <PageTitleAndFiltersPusher>
                                <HarvestEventsTable tableId="harvestEvents" />
                            </PageTitleAndFiltersPusher>
                        </InitialDataLoadedGate>
                    </InitialDataLoadedErrorGate>
                </React.Fragment>
            </PickScheduleLayoutGate>

            <PickScheduleLayoutGate targetedLayout="timeline">
                <InitialDataLoadedErrorGate
                    namespace="HARVEST_EVENTS_LOAD"
                    displayLogoutButton
                >
                    <InitialDataLoadedGate
                        namespace="HARVEST_EVENTS_LOAD"
                        LoadingComponent={
                            <PageWrapper>
                                <Loader active inline="centered" />
                            </PageWrapper>
                        }
                    >
                        <DisableUserSelect>
                            <div className="pick-schedule-container">
                                <div className="pick-schedule-container-inner">
                                    <PickSchedulePageTitleAndFilters />
                                    <EventsTimeline />
                                </div>
                                <CurrentSeasonInProgressGate>
                                    <RoleGate
                                        requiredRoles={[
                                            ADMIN,
                                            MANAGER,
                                            ASSISTANT_MANAGER
                                        ]}
                                    >
                                        <ResizableContainer>
                                            <EventsTable />
                                        </ResizableContainer>
                                    </RoleGate>
                                </CurrentSeasonInProgressGate>
                            </div>
                        </DisableUserSelect>
                    </InitialDataLoadedGate>
                </InitialDataLoadedErrorGate>
            </PickScheduleLayoutGate>
            <SeasonalEventDialog />
            <UnscheduleEventModal />
            <EventDragLayer />
        </SchemasWithEventTypeIdExistGate>
    </ErrorBoundary>
);

export default PickSchedule;
